import React from 'react'
import { Props } from './ArticleVideo'
import { ConfigurationContext } from 'common/context-providers/configuration-context'
import { brightcovePlayerWebId } from 'component-library/content/Video/providers/PlayerProps'

// TODO SWM-4689 these fall back IDs are masthead specific and should not be required
export const RssArticleVideo: React.FC<Props> = ({ videoDetails }) => {
    const videoId = videoDetails.id
    const config = React.useContext(ConfigurationContext)

    return (
        <iframe
            width="560"
            height="315"
            src={`https://players.brightcove.net/${config.brightcoveAccountId}/${brightcovePlayerWebId}_default/index.html?videoId=${videoId}`}
            frameBorder="0"
        />
    )
}
